var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseinline = function SvgCloseinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CA0821",
    fillRule: "evenodd",
    d: "M12 13.663 4.663 21 3 19.337 10.337 12 3 4.663 4.663 3 12 10.337 19.337 3 21 4.663 13.663 12 21 19.337 19.337 21z"
  })));
};
export default SvgCloseinline;